// LIFTED (slim) from bagel-dashboard api/internal-items — only getGTMAppTemplatePreview,
// used by TemplateFieldSettingsBox. Endpoint kept as-is; auth via axios interceptor.
import { axiosInstance } from '../../../api/axios-instance';
import type { TemplatePreviewResponse } from './integrations2.0';

export const getGTMAppTemplatePreview = async (
  appType: string,
  itemType: 'ideas' | 'evidences',
  fieldKey: string,
  template: string,
  _auth0?: unknown,
): Promise<TemplatePreviewResponse> => {
  const response = await axiosInstance.post<TemplatePreviewResponse>(
    `/internal/${itemType}/gtm-apps/${appType}/processing/${fieldKey}/validate-template`,
    { template },
  );
  return response.data;
};
